import { createFileRoute } from "@tanstack/react-router";
import CalendarPage from "@/site/pages/calendar";
import {
  REMINDER_TYPE_CODES,
  type ReminderTypeCode,
} from "@/site/components/reminders/reminder-shared";

// Old app's consolidated calendar lived at /calendar — keep the URL.
interface CalendarSearch {
  /** Omitted = large month-grid view (old default); "list" = mini-picker + list. */
  view?: "list";
  /** Omitted = all reminder types (old calendar_type_id filter). */
  type?: ReminderTypeCode;
  /** Contact group filter (PRD 02 §6.6) — server-side on GET /user/reminders. */
  group?: string;
}

function isReminderType(value: unknown): value is ReminderTypeCode {
  return typeof value === "string" && (REMINDER_TYPE_CODES as readonly string[]).includes(value);
}

export const Route = createFileRoute("/calendar")({
  validateSearch: (search: Record<string, unknown>): CalendarSearch => {
    const out: CalendarSearch = {};
    if (search.view === "list") out.view = "list";
    if (isReminderType(search.type)) out.type = search.type;
    if (typeof search.group === "string" && search.group) out.group = search.group;
    return out;
  },
  component: CalendarPage,
});
